import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as c3 from 'c3';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
@Component({
  selector: 'app-da-volume-popup-view',
  templateUrl: './da-volume-popup-view.component.html',
  styleUrls: ['./da-volume-popup-view.component.scss']
})
export class DaVolumePopupViewComponent implements OnInit, AfterViewInit {
  @ViewChild('graphDiv', { static: true }) graphDiv: ElementRef;
  @Output() factorySummary = new EventEmitter<any>(); //
  @Output() currentDate = new EventEmitter<any>(); //
  @Output() currrentFilter = new EventEmitter<any>(); //
  public oneDatee: any;
  public monthNameM: any;
  currentEndWeek: any;
  emitDataListList: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const daDateDate = this.getLocalStorageData('selectedDATimeFilter');
    this.currentEndWeek = '';
    this.emitDataListList = {
      appliedFilterType: daDateDate ? daDateDate.appliedFilterType : '',
      dateObj: new Date(daDateDate.endOfMonth),
      selectedHr: daDateDate.selectedHr,
      endWeekFromSelectedDate: daDateDate.endWeekFromSelectedDate,
      startQuarterMonth: null
    };
    this.oneDatee = this.emitDataListList.dateObj;
    this.monthNameM = this.oneDatee.toLocaleString('en-us', { month: 'short' });

  }
  getLocalStorageData(key: string) { //
    return JSON.parse(sessionStorage.getItem(key));
  }
  ngAfterViewInit() {
    if (this.data) {
      this.drawGraph();
    }
  }


  drawGraph() {
    c3.generate({
      bindto: this.graphDiv.nativeElement,
      size: {
        height: 450,
        width: 750
      },
      data: {
        x: 'x',
        columns: [
          ['x', ...this.data.xAxis],
          ['Sum of delivered Qty', ...this.data.deliveredQty],
          ['cost', ...this.data.cost]
        ],
        axes: {
          cost: 'y2'
        },
        types: {
          'Sum of delivered Qty': 'bar'
        },
        colors: {
          'Sum of delivered Qty': '#BF2A6E',
          cost: '#515CB4'
        },
        names: {
          cost: 'Cost %'
        }
      },
      point: {
        show: false
      },
      axis: {
        y2: {
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          tick: {
            format: (x) => x + '%'
          },
          show: true,
        },
        y: {
          label: {
            text: 'Delivered Quantity',
            position: 'outer-middle'
          },
          tick: {
            format: (x) => (x / this.data.divisionNumber) + this.data.signType
          },
          show: true,
        },
        x: {
          label: {
            text: ((this.emitDataListList &&
              (this.emitDataListList.appliedFilterType === 'quarter' || this.emitDataListList.appliedFilterType === 'year'))
              ? 'Month' : 'Date'),
            position: 'outer-center'
          },
        }
      },
      tooltip: {
        show: true,
        format: {
          title: (x: number) => (this.emitDataListList && (this.emitDataListList.appliedFilterType === 'quarter' ||
            this.emitDataListList.appliedFilterType === 'year')
            ? monthnames[x - 1] : (x + ' ' + this.monthNameM + ' ')),
          value: (x: number) => x > 100 ? (x / this.data.divisionNumber).toFixed(2) + this.data.signType : x.toFixed(2) + '%'
        }
      },
      bar: {
        width: 5
      }
    });
  }

}
